import { Box, Typography } from '@mui/material';
import {
	HowToBuySvg,
	MyAccountSvg,
	MyOrderSvg,
	PaymentMethodsSvg,
	ReturnsSvg,
	ShippingDeliveriesSvg,
} from '@/components/content/HelpCenter/parts/Icons';
import { CardLink } from '@/components/content/HelpCenter/parts/CardLink';
import {
	HelpCenterDescriptionSx,
	HelpCenterGridSx,
	HelpCenterTitleSx,
} from '@/components/content/HelpCenter/styles/main';
import { useLocalization } from '@/data/Localization';
import React, { useState } from 'react';
import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { DpContainer, DpContainerProps } from '@/components/blocks/DpContainer';

export const HelpCenter: React.FC<DpContainerProps> = (props) => {
	const [selectedId, setSelectedId] = useState('DPSV2HelpCenterHowToBuy');

	const handleClick = (id: string) => {
		setSelectedId(id);
	};

	const routes = useLocalization('Routes');

	const links = [
		{
			id: 'DPSV2HelpCenterHowToBuy',
			name: 'Cómo Comprar',
			href: `/${routes.HelpCenterHowToBuy.route.t()}`,
			icon: <HowToBuySvg />,
		},
		{
			id: 'DPSV2HelpCenterMyOrder',
			name: 'Mi Pedido',
			href: `/${routes.HelpCenterMyOrder.route.t()}`,
			icon: <MyOrderSvg />,
		},
		{
			id: 'DPSV2HelpCenterRefunds',
			name: 'Envío y Devoluciones',
			href: `/${routes.HelpCenterRefunds.route.t()}`,
			icon: <ReturnsSvg />,
		},
		{
			id: 'DPSV2HelpCenterPaymentMethods',
			name: 'Formas de Pago',
			href: `/${routes.HelpCenterPaymentMethods.route.t()}`,
			icon: <PaymentMethodsSvg />,
		},
		{
			id: 'DPSV2HelpCenterMyAccount',
			name: 'Mi Cuenta',
			href: `/${routes.HelpCenterMyAccount.route.t()}`,
			icon: <MyAccountSvg />,
		},
	];

	return (
		<DpContainer {...props}>
			<Typography component="h1" sx={HelpCenterTitleSx}>
				{'CENTRO DE AYUDA'}
			</Typography>
			<Typography component="h2" sx={HelpCenterDescriptionSx}>
				{'¿Con qué tema te podemos ayudar? Selecciona una categoría de las opciones aquí debajo.'}
			</Typography>
			<Box sx={HelpCenterGridSx}>
				{links.map(({ name, id, icon }) => (
					<CardLink
						key={name}
						name={name}
						isActive={id === selectedId}
						icon={icon}
						sx={{ height: '120px', minWidth: '200px', maxWidth: '200px' }}
						onClick={() => handleClick(id)}
					/>
				))}
			</Box>
			<ContentRecommendation
				id={selectedId}
				properties={{
					emsName: selectedId,
				}}
			/>
		</DpContainer>
	);
};
